import '../../../css/web/UserModalRenew.css'
import useTheme from '../layoutscommon/DarkModeStorage'
import React, {useEffect, useRef, useState} from "react";
import '../../../css/web/BtorageGlobalModal.css'
import {useTranslation} from "react-i18next";
import commonClose from "../../../assets/img/commonClose.png";
import creditCard from "../../../assets/img/blueCard.png";
import cardPayLogo from "../../../assets/img/purpleCard.png";
import kakaoPayLogo from "../../../assets/img/kakaoPayLogo.png";
import paycoLogo from "../../../assets/img/paycoLogo.png";
import tossPayLogo from "../../../assets/img/tossPayLogo.png";
import naverPayLogo from "../../../assets/img/naverPayLogo.png";
import samsungPayLogo from "../../../assets/img/samsungPayLogo.png";
import applePayLogo from "../../../assets/img/applePayLogo.png";
import mobilePayLogo from "../../../assets/img/mobilePayLogo.png";
import axios from "axios";
import {refreshAccessToken} from "../../../services/axiosInstance";
import MsgCheckModal from "./MsgCheckModal";
import BtorageGlobalPasswordModal from "./BtorageGlobalPasswordModal";
import CardRefundPolicy from "./CardRefundPolicy";
import {initPayAttempt, notifyCancel, PAY_USAGE} from "../../../services/PayGuard";


function KoreanPayModal({
                            koreanPayPopupSt,
                            closeKoreanPayPopup,
                            mbNum,
                            finalPayExpense,
                            afterOrderProcess,
                        usageType, // [결제누락 개선] 결제원장 용도
                        }) {
    const {t} = useTranslation();
    const [theme] = useTheme();
    const [payErrorMsg, setPayErrorMsg] = useState(false);
    const SSAT = sessionStorage.getItem('AToken');
    const LCAT = localStorage.getItem('AToken');

    const platformType = window.navigator.userAgent.includes('Mobi') ? '2' : '1';
    const modalWidth = platformType === '2' ? 350 : 400;

    const [payBtLoading, setPayBtLoading] = useState(false);
    const [payBtDisabled, setPayBtDisabled] = useState(false);
    const scrollViewRef = useRef(null);

    const [payerMail, setPayerMail] = useState("");
    const findEmail = () => {
        axios({
            method: 'get',
            url: '/member/findEmail',
            params: {
                mbNum: mbNum,
            },
        })
            .then((response) => {
                setPayerMail(response.data);
            })
            .catch((error) => {
                console.log("이메일 조회오류 : ", error)
            });
    };

    useEffect(() => {
        if (mbNum) {
            findEmail();
        }
    }, [mbNum])


    const [cardFee, setCardFee] = useState(0);
    const [finalCardExpense, setFinalCardExpense] = useState(0);

    useEffect(() => {
        let expenseNum;
        // 숫자 타입(예: 20000)
        if (typeof finalPayExpense === "number") {
            expenseNum = finalPayExpense;
        }
        // 문자열 타입(예: "20,000", "3000")
        else if (typeof finalPayExpense === "string") {
            // 쉼표가 포함된 경우
            if (finalPayExpense.includes(",")) {
                expenseNum = Number(finalPayExpense.replace(/,/g, ""));
            } else {
                expenseNum = Number(finalPayExpense);
            }
        } else {
            // 기타
            expenseNum = Number(finalPayExpense);
        }

        // NaN 방어(비정상 데이터일 경우 최소 999999로)
        if (isNaN(expenseNum) || expenseNum <= 0) expenseNum = 999999;

        const fee = Math.ceil(expenseNum * 0.027);
        const roundedFee = Math.ceil(fee / 10) * 10;

        setCardFee(roundedFee);
        setFinalCardExpense(expenseNum + roundedFee);
    }, [finalPayExpense]);

    // 10자리 숫자생성기
    const generateState = () => {
        const today = new Date();
        const year = today.getFullYear().toString().slice(2); // 연도 마지막 2자리
        const month = (today.getMonth() + 1).toString().padStart(2, '0'); // 월 (2자리)
        const day = today.getDate().toString().padStart(2, '0'); // 일 (2자리)

        const dateString = `${year}${month}${day}`; // yyMMdd 형식
        const randomLong = Math.floor(Math.random() * 10_000); // 4자리 랜덤 숫자
        const randomNumber = randomLong.toString().padStart(10, '0');
        return dateString + randomNumber;
    }

    const closePayErrorMsg = () => {
        setPayErrorMsg(false);
    }

    const [popupBlock, setPopupBlock] = useState(false);
    const closePopupBlock = () => {
        setPopupBlock(false);
    }

    const payWinRef = useRef(null);
    const pollingWorkerRef = useRef(null);
    const popupCheckIntervalRef = useRef(null);

    // ══════════════════════════════════════════════════════════════════════════════
    // [결제누락 개선]
    //  1) payNumRef : 실제 결제식별번호(payNum)를 보관하여 afterOrderProcess 로 전달한다.
    //     (기존에는 상수문자열을 넘겨 PG 결제건과 주문서를 연결할 수 없었다)
    //  2) 유예폴링 : 결제팝업이 닫혀도 즉시 폴링을 종료하지 않고 아래 시간동안 결제성공 여부를 계속 확인한다.
    //     (기존에는 즉시 terminate() 하여 결제완료 직후 팝업을 닫으면 주문서가 저장되지 않는 누락이 발생)
    // ══════════════════════════════════════════════════════════════════════════════
    const payNumRef = useRef(null);
    const graceTimeoutRef = useRef(null);
    const PAY_POLLING_GRACE_MS = 90000; // 팝업 닫힘 후 결제확인 유예시간 (90초)

    /** 폴링/타이머 일괄 정리 */
    const clearPayWatchers = () => {
        if (popupCheckIntervalRef.current) {
            clearInterval(popupCheckIntervalRef.current);
            popupCheckIntervalRef.current = null;
        }
        if (graceTimeoutRef.current) {
            clearTimeout(graceTimeoutRef.current);
            graceTimeoutRef.current = null;
        }
        if (pollingWorkerRef.current) {
            pollingWorkerRef.current.terminate();
            pollingWorkerRef.current = null;
        }
    };

    // 컴포넌트 언마운트 시 폴링 워커가 남지 않도록 정리
    useEffect(() => {
        return () => clearPayWatchers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [nonReadyMsg, setNonReadyMsg] = useState(false);
    const closeNonReadyMsg = () => {
        setNonReadyMsg(false);
    }

    // 추후 order에 수수료 포함된 finalCardExpense와 cardFee 전달하여 서버에 저장
    const payment = async () => {
        setPayBtLoading(true);
        setPayBtDisabled(true);

        if (focusPayMethod.value !== "creditcard") {
            setNonReadyMsg(true);
            setPayBtLoading(false);
            setPayBtDisabled(false);
            return;
        }

        try {
            const btoragePayNum = generateState();
            payNumRef.current = btoragePayNum;

            // [결제누락 개선] 결제팝업을 열기 전에 결제원장을 선기록한다.
            await initPayAttempt({
                payNum: btoragePayNum,
                payWay: 'PM09',
                usageType: usageType || PAY_USAGE.ORDER,
                amount: finalCardExpense,
            });

            const isMobile = platformType === '2';
            const popupWidth = 800;
            const popupHeight = 500;

            // PC 사이즈 설정
            const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
            const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
            const windowWidth = window.innerWidth || document.documentElement.clientWidth || window.screen.width;
            const windowHeight = window.innerHeight || document.documentElement.clientHeight || window.screen.height;
            const left = dualScreenLeft + (windowWidth - popupWidth) / 2;
            const top = dualScreenTop + (windowHeight - popupHeight) / 2;

            const windowFeatures = isMobile ? '' : `width=${popupWidth},height=${popupHeight},left=${left},top=${top},resizable=yes,scrollbars=yes`;
            // 브라우저별 팝업정책으로 미리 빈창 열기
            let payWin = window.open('', 'PayletterPay', windowFeatures);
            payWinRef.current = payWin;

            // 국내결제는 returnUrl로 콜백
            const callbackUrl = `https://btorage.com/api/btoragePay/saveDsTempPayNum?mbNum=${mbNum}&payNum=${btoragePayNum}&type=1`;
            const returnUrl = `https://btorage.com/api/btoragePay/PaymentLoading?autoPayFl=0&mbNum=${mbNum}&payNum=${btoragePayNum}&type=1`;

            const res = await axios.post('/btoragePay/dsPayOpenWindow', {
                pgcode: focusPayMethod.value,
                user_id: payerMail,
                payNum: btoragePayNum,
                service_name: "Btorage",
                dsAmount: finalCardExpense,
                product_name: "Btorage Payments",
                email_flag: "Y",
                email_addr : payerMail,
                autopay_flag: "N",
                return_url: returnUrl,
                callback_url: callbackUrl,
            }, );

            console.log("payWin : ", payWin)
            console.log("응답값 : ", res?.data)

            // 팝업 && 데이터 보장
            if (payWin && res?.data) {
                console.log("Pop-up open")
                // ✅ polling 시작 (Web Worker 방식)
                startPollingWithWorker(mbNum, btoragePayNum, LCAT || SSAT);
                payWin.location.href = platformType === '2' ? res.data.mobile_url : res.data.online_url;
            } else {
                setPopupBlock(true);
                setPayBtLoading(false);
                setPayBtDisabled(false);
                return;
            }

            // 팝업 닫힘 감지
            popupCheckIntervalRef.current = setInterval(() => {
                if (payWinRef.current && payWinRef.current.closed) {
                    setPayBtLoading(false);
                    setPayBtDisabled(false);
                    clearInterval(popupCheckIntervalRef.current);
                    popupCheckIntervalRef.current = null;

                    // [결제누락 개선] 팝업이 닫혀도 폴링을 즉시 종료하지 않고 유예시간동안 결제성공 여부를 계속 확인한다.
                    if (pollingWorkerRef.current && !graceTimeoutRef.current) {
                        graceTimeoutRef.current = setTimeout(() => {
                            if (pollingWorkerRef.current) {
                                pollingWorkerRef.current.terminate();
                                pollingWorkerRef.current = null;
                                notifyCancel({
                                    payNum: payNumRef.current,
                                    failReason: 'Payment popup closed and not confirmed within grace period',
                                });
                            }
                            graceTimeoutRef.current = null;
                        }, PAY_POLLING_GRACE_MS);
                    }
                }
            }, 500);

        } catch (err) {
            setPayErrorMsg(true);
            setPayBtLoading(false);
            setPayBtDisabled(false);
        }
    }

    // ✅ polling 전용 함수 (Web Worker 생성)
    /** 폴링 중 토큰만료로 재발급을 시도한 마지막 시각 (2초 폴링마다 두드리지 않도록 조절) */
    const lastTokenRenewRef = useRef(0);

    const startPollingWithWorker = (mbNum, payNum, token) => {
        if (pollingWorkerRef.current) {
            pollingWorkerRef.current.terminate();
        }

        const workerCode = () => {
            let timer = null;
            let authToken = null;

            // eslint-disable-next-line no-restricted-globals
            self.onmessage = async function (e) {
                /*
                 * [토큰교체 메시지] 메인스레드가 갱신된 액세스토큰을 보내온 경우.
                 *  토큰만 바꿔 끼우고 즉시 끝낸다. 여기서 빠져나가지 않으면 아래
                 *  setInterval 이 하나 더 생겨 폴링이 중복 실행된다.
                 */
                if (e.data && e.data.type === 'TOKEN') {
                    if (e.data.token) authToken = e.data.token;
                    return;
                }

                const { mbNum, payNum, token, url } = e.data;
                authToken = token;

                const poll = async () => {
                    try {
                        const res = await fetch(`${url}?payNum=${payNum}&type=1`, {
                            method: 'POST',
                            headers: {
                                Authorization: authToken,
                            },
                        });
                        /*
                         * [중요] 401 은 '액세스토큰이 만료됐다' 는 뜻이다.
                         *  워커는 시작할 때 받은 토큰을 그대로 들고 있으므로, 여기서
                         *  그냥 넘기면 같은 토큰으로 영원히 401 만 받으며 결제완료를
                         *  끝까지 감지하지 못한다 (= 결제누락).
                         *  메인스레드에 새 토큰을 요청하고, 폴링은 멈추지 않는다.
                         */
                        if (res.status === 401) {
                            // eslint-disable-next-line no-restricted-globals
                            self.postMessage({ status: 'TOKEN_EXPIRED' });
                            return;
                        }
                        if (!res.ok) {
                            throw new Error(`웹 워커 poll.res 응답에러 : ${res.status}`);
                        }
                        const data = await res.json();
                        if (data) {
                            clearInterval(timer);
                            // eslint-disable-next-line no-restricted-globals
                            self.postMessage({ status: 'COMPLETED' });
                        }
                    } catch (err) {
                        console.error('Polling error:', err);
                        // eslint-disable-next-line no-restricted-globals
                        self.postMessage({ status: 'ERROR', error: err.message });
                        // 통신 오류 시에도 무시하고 polling 지속
                    }
                };

                // [결제누락 개선] 폴링 주기 5초 -> 2초 (결제성공 감지 지연으로 인한 누락 최소화)
                await poll();
                timer = setInterval(poll, 2000);
            };
        };

        const blob = new Blob(['(' + workerCode.toString() + ')()'], { type: 'application/javascript' });
        const worker = new Worker(URL.createObjectURL(blob));
        pollingWorkerRef.current = worker;

        const fullUrl = new URL('/api/btoragePay/selectedTempPayNum', window.location.origin).href;
        worker.postMessage({ mbNum, payNum, token, url: fullUrl });

        worker.onmessage = function (e) {
            if (e.data.status === 'COMPLETED') {
                setPayBtLoading(false);
                setPayBtDisabled(false);
                if (payWinRef.current && !payWinRef.current.closed) {
                    payWinRef.current.close();
                }
                clearPayWatchers();
                // [결제누락 개선] 상수문자열이 아닌 실제 결제식별번호(payNum)를 전달하여 주문서에 저장되도록 한다.
                afterOrderProcess("COMPLETED", payNumRef.current || payNum, "koreanPay", cardFee);
            } else if (e.data.status === 'TOKEN_EXPIRED') {
                /*
                 * 폴링 중 액세스토큰이 만료됐다. 조용히 갱신해서 워커에 새 토큰을 넘긴다.
                 *  갱신이 실패해도 폴링은 계속 돌고 있으므로, 30초에 한 번만 시도해
                 *  (폴링주기 2초마다 재발급을 두드리는 것을 막는다) 서버 부담을 피한다.
                 */
                const now = Date.now();
                if (now - lastTokenRenewRef.current >= 30000) {
                    lastTokenRenewRef.current = now;
                    refreshAccessToken().then((fresh) => {
                        if (fresh && pollingWorkerRef.current) {
                            pollingWorkerRef.current.postMessage({ type: 'TOKEN', token: fresh });
                        }
                    });
                }
            } else if (e.data.status === 'ERROR') {
                console.error('Error from polling worker:', e.data.error);
            }
        };
    };

    const payMethods = [
        {
            label: "신용카드",
            value: "creditcard",
            logo: cardPayLogo,
            logoBg: "transparent",
        },
        {
            label: "카카오페이",
            value: "kakaopay",
            logo: kakaoPayLogo,
            logoBg: "#fef01b",
        },
        {
            label: "페이코",
            value: "payco",
            logo: paycoLogo,
            logoBg: "#EF1110",
        },
        {
            label: "토스페이",
            value: "toss",
            logo: tossPayLogo,
            logoBg: "transparent",
        },
        {
            label: "네이버페이",
            value: "naverpay",
            logo: naverPayLogo,
            logoBg: "green",
        },
        {
            label: "삼성페이",
            value: "samsungpay",
            logo: samsungPayLogo,
            logoBg: "#4169C7",
        },
        {
            label: "애플페이",
            value: "applepay",
            logo: applePayLogo,
            logoBg: "#EAEAEA",
        },
        {
            label: "휴대폰결제",
            value: "mobile",
            logo: mobilePayLogo,
            logoBg: "transparent",
        },
        // 추가 필요 시 이곳에 항목만 추가하면 됨!
    ];

    const [focusPayMethod, setFocusPayMethod] = useState({
        label: "신용카드",
        value: "creditcard",
    });

    const handleSelect = (method) => {
        setFocusPayMethod({label: method.label, value: method.value});
    };


    return (
        <div className="btorage-pay-modal-container md-scope" data-theme={theme}>
            <div className="btorage-pay-modal-frame" style={{width: `${modalWidth}px`}}>
                <div className="btorage-pay-modal-scroll-area p-r-10" ref={scrollViewRef}>
                    <div className="font-t-cont">
                        {/*헤더*/}
                        <div className="display-flex just-cont-fend m-b-20">
                            <img onClick={closeKoreanPayPopup} className="c-point wd-30 ht-30 m-a-opc-06"
                                 src={commonClose}
                                 alt="close"/>
                        </div>
                        {/*바디*/}
                        <div className="btorage-pay-modal-body-container">
                            <div className="btorage-pay-modal-header-container">
                                <div className="btorage-pay-modal-header-frame">
                                    <p className="btorage-pay-modal-header-text">{t(`modHeader10`)}</p>
                                </div>
                                <div>
                                    <img src={creditCard} className="wd-40 ht-40" alt="btoragePay"/>
                                </div>
                            </div>

                            <div className="btorage-pay-modal-price-container">
                                <div className="btorage-pay-modal-price-frame">
                                    <a className="btorage-pay-modal-price-text1">{t(`modSHeader3`)}</a>
                                    <a className="btorage-pay-modal-price-text2">{finalPayExpense && finalPayExpense.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a>
                                </div>
                                <div className="btorage-pay-modal-price-frame">
                                    <a className="btorage-pay-modal-price-text1">+ {t('bpmTx17')}(2.7%)</a>
                                    <div>
                                        <a className="btorage-pay-modal-price-text2">{cardFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a>
                                    </div>
                                </div>
                            </div>

                            <div className="btorage-pay-modal-price-frame font-s-14"
                                 style={{padding: "10px 10px 0 10px"}}>
                                <a className="btorage-pay-modal-price-text1">{t('modFinalPay')}</a>
                                <div>
                                    <a className="btorage-pay-modal-price-text2 font-b">{finalCardExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a>
                                </div>
                            </div>

                        </div>

                        {/*결제수단*/}
                        <div className="m-t-20 border-thin border-rd6">
                            <div className="ht40 pd10 border-thin">
                                <p className="font-s-14">{t('smPayty')}</p>
                            </div>
                            {/* 결제수단 영역 */}
                            <div className="pd15" style={{backgroundColor: "var(--md-panel, #FAFAFA)"}}>
                                {/* 결제수단 3개씩 자동 줄바꿈 (grid) */}
                                <div style={{display: "grid", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", gap: "8px",}}>
                                    {payMethods.map((method) => (
                                        <div
                                            key={method.value}
                                            className="display-flex flex-column align-center just-cont-center border-rd6 c-point"
                                            onClick={() => handleSelect(method)}
                                            style={{
                                                width: "100%", // ← 중요: 고정 너비 제거
                                                backgroundColor: "var(--md-surface, white)",
                                                border:
                                                    focusPayMethod.value === method.value
                                                        ? "2px solid darkorange"
                                                        : "1px solid #F0F0F0",
                                                boxShadow:
                                                    focusPayMethod.value === method.value ? "0 0 6px #1e90ff33" : "none",
                                                transition: "border 0.2s, box-shadow 0.2s",
                                                padding: "12px 0",
                                            }}
                                        >
                                            {/* 로고 배경 영역 */}
                                            <div
                                                className="wd-40 ht-40 user-center border-rd6 m-b-8"
                                                style={{backgroundColor: method.logoBg}}>
                                                <img
                                                    className="object-fit-contain border-rd6"
                                                    src={method.logo}
                                                    alt={method.label}
                                                    style={{
                                                        width: method.label === "신용카드" ? "50px" : "40px",
                                                        height: method.label === "신용카드" ? "50px" : "40px",
                                                    }}/>
                                            </div>
                                            {/* 결제수단 명칭 */}
                                            <p
                                                className="font-s-14 text-center"
                                                style={{
                                                    color:
                                                        focusPayMethod.value === method.value
                                                            ? "darkorange"
                                                            : "#222",
                                                    fontWeight:
                                                        focusPayMethod.value === method.value ? 600 : 400,
                                                }}>
                                                {method.label}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                    </div>


                    {/*푸터*/}
                    <div className="font-t-cont m-t-30">

                        <div className="user-center m-t-20 m-b-50">
                            <style>
                                {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                            </style>
                            <button onClick={payment} disabled={payBtDisabled}
                                    className="orderItemHandleBt wd-100pc ht-50 font-s-16 border-rd4 user-center">
                                {payBtLoading ? (
                                    <div className="spinner"></div>
                                ) : (
                                    "Payment"
                                )}
                            </button>
                        </div>

                    </div>

                </div>
            </div>


            {payErrorMsg ?
                <MsgCheckModal payErrorMsg={payErrorMsg} closePayErrorMsg={closePayErrorMsg}/>
                :
                    popupBlock ?
                        <MsgCheckModal popupBlock={popupBlock}
                                       closePopupBlock={closePopupBlock}/>
                                :
                        nonReadyMsg ?
                            <MsgCheckModal nonReadyMsg={nonReadyMsg}
                                           closeNonReadyMsg={closeNonReadyMsg}/>
                            :
                                null
            }


        </div>
    )
}

export default KoreanPayModal
